import { Image } from "@atoms";


export const AuthSectionTemplate = (): JSX.Element => {
  return (
    <>
    {/* Left side - Dark blue background with logo */}
    <div className="relative hidden lg:flex lg:w-1/2 min-h-screen bg-primary-lightest">
    {/* Logo at top */}
    <div className="absolute top-8 left-8">
      <div className="flex items-center gap-2">
        <Image variant="parachuteLogoWithText" height={42} width={160} />
        {/* <span className="text-white text-xl font-medium">Parachute</span> */}
      </div>
    </div>
    
    {/* Background image centered */}
    <div className="flex-1 flex items-center justify-center">
      <div className="w-[50%] h-[50%] flex items-center justify-center">
        <Image 
          variant="backgroundParachute"
          width="100%"
          height="100%"
          highResolution={true}
        />
      </div>
    </div>
  </div>
    </>
  );
};
